<template>
  <div>
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('description.deleteModalDescription')"
      :confirm="deleteItem"
      v-model="deleteItemConfirmationModal"
    />
    <v-card elevation="1">
      <v-card-title style="color: var(--darkBlue)">
        <v-row>
          <v-col class="text-lg-left text-center" lg="5" cols="12">
            <h3>{{ $t('navigationDrawerMenu.fscGroups') }}</h3>
          </v-col>
        </v-row>
        <v-icon
          v-if="
            $store.state.Type === 'Supplier' ||
            $store.state.Type === 'Accountant'
          "
          @click="
            costDialog = true;
            editFlag = false;
            isGroupNameFromServiceCall = false;

            getPriceLists();
          "
          small
          class="mr-6"
          style="font-size: 32px"
        >
          mdi-plus-box-outline
        </v-icon>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </v-card-title>

      <v-divider />
      <v-data-table
        :headers="headers"
        :items="list"
        :options="{
          itemsPerPage,
        }"
        style="padding: 0 16px"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :no-data-text="$t('messages.noData')"
        ><!-- eslint-disable -->
        <template v-slot:item.PriceListCount="{ item }">
          {{ item.PriceListIds?.length || 0 }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="updateCost(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t('labels.tooltipEdit') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    deleteItemConfirmationModal = true;
                    selectedItem = item.Id;
                  "
                >
                  mdi-trash-can
                </v-icon>
              </template>
              <span>{{ $t('labels.deleteKey') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="costDialog" @input="resetDialog" max-width="800">
        <v-card class="popup-card" elevation="1">
          <v-card-title
            class="popupHeadline d-flex justify-center"
            style="font-size: 16px"
          >
            {{ $t('labels.addAdditionalCost') }}
          </v-card-title>

          <v-divider></v-divider>
          <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
            <v-card-text class="mt-2">
              <form @submit.prevent="handleSubmit(submitCost)">
                <v-row style="padding-bottom: 15px">
                  <FormElement
                    v-for="(element, index) in formElement"
                    :key="
                      element.key.parent + '_' + element.key.child + '_' + index
                    "
                    v-model="$data[element.key.parent][element.key.child]"
                    :validationLabel="$t(element.validationLabel)"
                    :rules="element.rules"
                    :formLabel="$t(element.formLabel)"
                    :onChange="element.onChange"
                    :formType="element.formType"
                    :lg="element.lg"
                    :cols="element.cols"
                    :hidden="element.hidden"
                    :labelShown="element.labelShown"
                    :topLabel="element.topLabel"
                    :active="element.active"
                    :placeholder="$t(element.placeholder)"
                    :willBeEliminated="false"
                    :classes="element.classes"
                    :hideDetails="element.hideDetails"
                  />
                </v-row>

                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: #0077d5;
                      padding: 2vh 3vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    type="submit"
                    color="primary"
                  >
                    {{
                      !editFlag ? $t('buttons.add') : $t('buttons.update')
                    }}</v-btn
                  >
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: var(--red);
                      padding: 2vh 2vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    @click="costDialog = false"
                    >{{ $t('buttons.cancel') }}</v-btn
                  >
                </v-card-actions>
              </form>
            </v-card-text>
          </ValidationObserver>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import RefreshButton from '../components/RefreshButton.vue';
import FormElement from '../components/FormElement.vue';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';
import AdditionalCostsServices from '../services/AdditionalCostsServices';

export default {
  data: () => ({
    users: [],
    form: {
      IntegrationLogistic: -1,
      PaymetTime: 0,
    },
    costDialog: false,
    headers: [],
    itemsPerPageOptions: [],
    itemsPerPage: 99999999999999999,
    page: 1,
    totalItems: 0,

    perPageValues: [
      {
        name: '5',
        value: 5,
      },
      {
        name: '10',
        value: 10,
      },
      {
        name: '15',
        value: 15,
      },
      {
        name: '30',
        value: 30,
      },
      {
        name: '50',
        value: 50,
      },
      {
        name: '100',
        value: 100,
      },
    ],

    deleteItemConfirmationModal: false,
    selectedItem: '',
    list: [],
    costParameters: [],
    displayCostParameters: [],
    editFlag: false,

    priceList: [],
    isUpdatingPriceListIds: false,

    types: [],
    isGroupNameFromServiceCall: false,
  }),
  async mounted() {
    this.headers = [
      {
        text: this.$t('labels.name'),
        value: 'GroupName',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.fscRate'),
        value: 'FscRate',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.priceListCount'),
        value: 'PriceListCount',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.actions'),
        value: 'actions',
        sortable: false,
      },
    ];

    this.getItems();
  },
  watch: {
    costDialog(newValue) {
      if (!newValue) {
        this.resetDialog();
      }
    },
    'form.PriceListIds': {
      handler(newIds, oldIds) {
        if (this.isUpdatingPriceListIds) {
          return;
        }

        if (
          !oldIds ||
          !newIds ||
          JSON.stringify(newIds) === JSON.stringify(oldIds)
        ) {
          return;
        }

        const availableIds = new Set(this.priceList.map((item) => item.Id));
        const allNewIdsAreAvailable = newIds.every((id) =>
          availableIds.has(id)
        );

        if (allNewIdsAreAvailable && oldIds && oldIds.length > 0) {
          const idsToPreserve = oldIds.filter((id) => !availableIds.has(id));

          if (idsToPreserve.length > 0) {
            const newIdsSet = new Set(newIds);
            const mergedIds = Array.from(
              new Set([...newIdsSet, ...idsToPreserve])
            );

            this.isUpdatingPriceListIds = true;
            this.$nextTick(() => {
              this.form.PriceListIds = mergedIds;
              this.$nextTick(() => {
                this.isUpdatingPriceListIds = false;
              });
            });
            return;
          }
        }
      },
      deep: true,
    },
  },
  components: {
    RefreshButton,
    FormElement,
    ConfirmationModal,
  },
  computed: {
    additionalCostTypes() {
      if (!this.form.LogisticType) return [];

      let specialTypes = [];
      if (this.form.LogisticType == 1) {
        specialTypes = this.types.filter((i) => i.value !== 2);
      } else {
        specialTypes = this.types.filter((i) => i.value !== 8 && i.value !== 9);
      }

      return specialTypes;
    },
    filteredSelectedItems() {
      if (!this.form.PriceListIds || !Array.isArray(this.form.PriceListIds)) {
        return [];
      }
      if (!this.priceList || !Array.isArray(this.priceList)) {
        return [];
      }
      const availableIds = new Set(this.priceList.map((item) => item.Id));
      return this.form.PriceListIds.filter((id) => availableIds.has(id));
    },
    formElement() {
      return [
        {
          key: {
            parent: 'form',
            child: 'IntegrationLogistic',
          },
          validationLabel: 'labels.integrationLogisticFilter',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'select',
            items: {
              data: [
                { Value: -1, Name: this.$t('labels.All') },
                { Value: 1, Name: 'Fedex' },
                { Value: 2, Name: 'UPS' },
                { Value: 4, Name: 'DHL' },
              ],
              value: 'Value',
              text: 'Name',
            },
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.integrationLogisticFilter',
          onChange: () => {
            this.$nextTick(() => {
              if (
                !this.isGroupNameFromServiceCall &&
                this.form.IntegrationLogistic !== -1
              ) {
                const integrationLogisticOptions = [
                  { Value: -1, Name: this.$t('labels.All') },
                  { Value: 1, Name: 'Fedex' },
                  { Value: 2, Name: 'UPS' },
                  { Value: 4, Name: 'DHL' },
                ];
                const selectedOption = integrationLogisticOptions.find(
                  (option) => option.Value === this.form.IntegrationLogistic
                );
                if (selectedOption) {
                  this.$set(this.form, 'GroupName', selectedOption.Name);
                }
              }
              this.getPriceLists(this.form.Id);
            });
          },
          hideDetails: true,
        },
        {
          key: {
            parent: 'form',
            child: 'PriceListIds',
          },
          formType: {
            name: 'checkTable',
            visible: true,
            unselectedItems: this.priceList,
            selectedItems: this.filteredSelectedItems,
          },
          labelShown: false,
        },
        {
          key: {
            parent: 'form',
            child: 'GroupName',
          },
          rules: '',
          validationLabel: 'labels.name',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          placeholder: 'labels.name',
          onChange: () => {
            const integrationLogisticOptions = [
              { Value: -1, Name: this.$t('labels.All') },
              { Value: 1, Name: 'Fedex' },
              { Value: 2, Name: 'UPS' },
              { Value: 4, Name: 'DHL' },
            ];
            const currentIntegrationLogistic = integrationLogisticOptions.find(
              (option) => option.Value === this.form.IntegrationLogistic
            );
            if (
              currentIntegrationLogistic &&
              this.form.GroupName !== currentIntegrationLogistic.Name
            ) {
              this.isGroupNameFromServiceCall = true;
            }
          },
        },
        {
          key: {
            parent: 'form',
            child: 'FscRate',
          },
          rules: 'required|double',
          validationLabel: 'labels.fscRate',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          placeholder: 'labels.fscRate',
        },
      ];
    },
  },
  methods: {
    async getPriceLists(fscGroupId = null) {
      this.$store.state.loadingStatus = true;
      await AdditionalCostsServices.getFscPriceLists(
        fscGroupId,
        this.form.IntegrationLogistic
      )
        .then((response) => {
          this.priceList = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getItems() {
      this.$store.state.loadingStatus = true;
      AdditionalCostsServices.getFscGroups()
        .then((response) => {
          this.list = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    resetDialog() {
      this.$refs.observer.reset();
      this.form = {};
      this.isGroupNameFromServiceCall = false;
    },

    deleteItem() {
      if (this.selectedItem) {
        this.$store.state.loadingStatus = true;
        AdditionalCostsServices.deleteFscGroup(this.selectedItem)
          .then((response) => {
            window.showSuccess(
              this.$t('messages.successfulDelete', {
                value: this.$t('labels.fscGroup'),
              })
            );
            this.getItems();
          })
          .catch(window.showError)
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
    submitCost() {
      this.$store.state.loadingStatus = true;
      delete this.form.SupplierId;
      AdditionalCostsServices[
        (this.editFlag ? 'update' : 'create') + 'FscGroup'
      ](this.form)
        .then((response) => {
          this.getItems();
          this.costDialog = false;
          window.showSuccess(
            this.$t(
              `messages.${
                this.editFlag
                  ? 'successfulUpdateGeneral'
                  : 'successfulAddGeneral'
              }`
            )
          );
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    async updateCost(item) {
      await this.getPriceLists(item?.Id);

      this.form = Object.assign({}, item);
      this.form.PriceListIds = item.PriceListIds;
      this.form.IntegrationLogistic = -1;
      this.isGroupNameFromServiceCall = !!this.form.GroupName;
      this.costDialog = true;
      this.editFlag = true;
    },
  },
};
</script>
